import React, {Component} from 'react';
import './Campaign.css';
import {fetchCampaign, updateCampaignSort, publishToJira } from "../../actions/campaignActions";
import {connect} from "react-redux";
import UnitRow from "./UnitRow";
import '../Brand/brand.css';
import CampaignModal from '../Modal/Campaign';
import SVG from 'react-inlinesvg';
import caretDown from '../../assets/caret-down.svg';
import Loading from "../Shared/Loading";
import UnitModal from "../Modal/UnitModal";
import {Link} from 'react-router-dom'
import AccessControl from "../../utils/AccessControl";
import queryString from "query-string";
import {fetchBrand, updateBrandSort} from "../../actions/brandActions";
import {getCreativeInfo} from "../../actions/campaignActions";
import Published from "../Modal/Published";
import PublishedModal from '../Modal/Published';
import lock from "../../assets/lock-480x480.png";
import ToolTips from "../Shared/ToolTips";
import CampaignModalContainer from "../Modal/campaignModalContainer";
import {get} from "../../utils/api";
import Banner from "../Shared/banner";
// import Notification from "../Shared/Notification";



class Campaign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: {
                unit: false,
                campaign: false,
                jira: false,
                banner: false
            },
            epic_error: false,
            socket_status: false,
            banner_message: false,
        }
    }
    componentDidMount() {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let that = this;
        if (typeof queryParams.sort_col === 'string' && typeof queryParams.sort_dir === 'string') {
            this.props.dispatch(updateCampaignSort(queryParams.sort_col, queryParams.sort_dir));
        } else {
            this.props.dispatch(updateCampaignSort(false,false));
        }
        this.props.dispatch(fetchCampaign(this.props.match.params.cid)).then((res)=>{
            if(this.props.permission === false){
                this.props.history.push('/unauthorized');
            }
        });
        this.props.dispatch(getCreativeInfo());
    }

    componentDidUpdate(prevProps) {
        if((prevProps.sort_dir !== this.props.sort_dir || prevProps.sort_col !== this.props.sort_col) && !this.props.loading){
            this.props.dispatch(fetchCampaign(this.props.match.params.cid));
        }
    }

    toggleModal = (type, show) => {
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };

    getSortClass = (column) => {
        let classes = 'sort-column';
        if (this.props.sort_col === column) {
            classes += ' active';
        }
        if(this.props.sort_dir === ""){
            classes += ' sort-desc';
        } else {
            classes += ' sort-' + this.props.sort_dir;
        }
        return classes;
    };

    handleSortClick = (column) => {
        let direction = this.props.sort_dir === 'asc' ? 'desc' : 'asc';
        this.props.dispatch(updateCampaignSort(column, direction));
        let url = '/campaign/' + this.props.match.params.cid;
        if (typeof column === 'string' && typeof direction === 'string') {
            url += `?sort_col=${column}&sort_dir=${direction}`;
        }
        this.props.history.push(url)
    };
    publishToJira = () => {
        let cid = this.props.campaign.campaign.id
        this.props.dispatch(publishToJira(cid));
    }
    checkForMocks = () => {
        let mock = false;
        let units = this.props.campaign.units;
        if(units.length > 0){
            for (let i = 0; i < units.length ; i++) {
                if(units[i].unit_type === 'mock'){
                    mock = true;
                }
            }
        }
       return mock;
    }
    getBannerInfo = (message) => {
        if(message !== ""){
            this.setState({
                banner_message: message,
                showModal: {
                    banner: true
                }})
        }
    }
    displayComponent = () => {
        const campaign = this.props.campaign.campaign;
        if(this.state.showModal.campaign || this.state.showModal.unit){
            return(
                <CampaignModalContainer
                        user={this.props.user}
                        toggleModal={this.toggleModal}
                        create={false}
                        modal={this.state.showModal}
                        inputOptions={this.props.campaign.meta}
                        stages='campaignPage'
                        campaign={campaign}
                        getBanner={this.getBannerInfo}
                        fullUserFlow={false}
                    />
            )
        }
    }

    render() {
        const units = this.props.campaign.campaign.units;
        let campaign = this.props.campaign.campaign;
        let verticals = campaign.campaign.verticals !== undefined ? campaign.campaign.verticals : [];
        let subcat = campaign.campaign.subcategory !== undefined ? campaign.campaign.subcategory : [];
        return (
            <div className="section-campaign">
                {this.displayComponent()}
                {this.props.jiraLoading ? <div className="jira-load"><Loading/><p>Tickets are being generated. This may take some time. Do not refresh the page.</p> </div> : this.props.loading || this.props.unitLoading ? <Loading/> :
                    <div>
                        <div className="campaign-header-page">
                            <div className="campaign-header-info">
                                <Link to={`/brand/${campaign.campaign.brand_id}`}>
                                    {campaign.campaign.brand_hide === 1 ? <span id="lock-container"><ToolTips content="Hidden Brand" data="hb"><img src={lock} alt="brand is hidden"/></ToolTips></span> : ""} <span className="underline">{campaign.campaign.brand_value}</span></Link>
                                <span className="divider">|</span> <h1>{campaign.campaign.name}</h1>
                                <div className="campaign-vertical-container">
                                    {verticals.map((v, key) => {
                                        return(
                                            <p key={key} className="campaign-vertical"> {v.name}{key === verticals.length - 1 && subcat.length - 1 ? '' : ','} </p>
                                        )
                                    })}
                                    {subcat.map((s, k) => (
                                        <p key={k} className="campaign-vertical">{s.value} {k === subcat.length - 1 ? '' : ','} </p>
                                    ))}
                                </div>
                            </div>
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['editor', 'admin']}
                            >
                                <div className="campaign-footer">
                                    <button
                                        className="button button--blue-outline"
                                        onClick={() => this.toggleModal('unit', true)}>Add Creative</button>
                                    <div>
                                        {/*{this.checkForMocks() ?*/}
                                        {/*    <button className="button button--blue publish"*/}
                                        {/*            onClick={() => this.toggleModal('jira', true)}>Publish to JIRA</button> : "" }*/}
                                        <button className="button button--blue"
                                                onClick={() => this.toggleModal('campaign', true)}>Edit Campaign
                                        </button>
                                    </div>
                                </div>
                            </AccessControl>
                        </div>
                        {this.state.showModal.banner && <Banner message={this.state.banner_message}  toggleModal={this.toggleModal} />}
                    <div className="campaign-body search-table-wrapper">
                        <table className="table table-sort c-table-wrapper">
                            <thead>
                            <tr>
                                <th className="creative-tr">Creative</th>
                                <th>Creative Format</th>
                                <th>Functionality</th>
                                <th>Designer</th>
                                <th onClick={() => this.handleSortClick('date')}
                                    className={this.getSortClass('date')}>Date
                                    <span className="caret">
                                        <SVG src={caretDown}/>
                                    </span>
                                </th>
                                <th>Links</th>
                            </tr>
                            </thead>
                            <tbody>
                            {campaign.units.map((unit) => (
                                <UnitRow key={`${unit.unit_type}-${unit.id}`} unit={unit}/>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    {this.state.showModal.jira && <PublishedModal
                        toggleModal={this.toggleModal}
                        campaign={true}
                        mockUnits={campaign.units}
                        message={this.props.message}
                        campaignName={campaign}
                        e_message={this.props.e_message}
                        jira_errs={this.props.jira_errs}
                        urls={this.props.jira_url}
                        publishToJira={this.publishToJira}
                    />}
                </div>
                }
            </div>
        )
    }
}


const mapStateToProps = state => ({
    campaign: state.campaign,
    units: state.campaign.units,
    sort_col: state.campaign.sort_col,
    sort_dir: state.campaign.sort_dir,
    loading: state.campaign.loading,
    message: state.campaign.message,
    e_message: state.campaign.err_message,
    jira_url: state.campaign.jira_url,
    jira_errs: state.campaign.jira_errs,
    inputOptions: state.campaign.campaign.input_options,
    unitLoading: state.unit.loading,
    jiraLoading: state.campaign.jiraLoading,
    user: state.user,
    permission: state.campaign.permission
});

export default connect(mapStateToProps)(Campaign);
